import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api, setToken } from "@/lib/oraya-api";
import { useAuth } from "@/context/AuthContext";
import { OrayaMark } from "@/components/site/primitives";

// Handles the Emergent Google OAuth return: #session_id=...
export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = location.hash || window.location.hash;
    const sid = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    if (!sid) { navigate("/admin", { replace: true }); return; }
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sid });
        if (data.access_token) setToken(data.access_token);
        setUser(data);
        const toCommand = window.location.pathname.startsWith("/command");
        window.history.replaceState(null, "", toCommand ? "/command" : "/admin");
        if (toCommand) { navigate("/command", { replace: true }); return; }
        if (data.role === "admin") navigate("/admin/dashboard", { replace: true });
        else navigate("/admin", { replace: true, state: { denied: true } });
      } catch {
        navigate(window.location.pathname.startsWith("/command") ? "/command/login" : "/admin", { replace: true, state: { error: true } });
      }
    })();
  }, [location.hash, navigate, setUser]);

  return (
    <div data-theme="dark" className="min-h-screen bg-oraya-black flex flex-col items-center justify-center gap-4">
      <OrayaMark size={40} spin />
      <p className="text-oraya-slate text-sm">Signing you in…</p>
    </div>
  );
}
